// extracted by mini-css-extract-plugin
export var button__container = "Button-module--button__container--c0ade";
export var button_large = "Button-module--button_large--efa42";
export var button_standard = "Button-module--button_standard--8976c";
export var button_with_border = "Button-module--button_with_border--e488f";
export var color_black = "Button-module--color_black--e311c";
export var color_black_border = "Button-module--color_black_border--18bd2";
export var color_blue = "Button-module--color_blue--51038";
export var color_blue_border = "Button-module--color_blue_border--cfa2f";
export var color_green = "Button-module--color_green--b8dcf";
export var color_green_border = "Button-module--color_green_border--1484b";
export var color_lightblue = "Button-module--color_lightblue--c1ece";
export var color_lightblue_border = "Button-module--color_lightblue_border--65c5f";
export var color_orange = "Button-module--color_orange--a149f";
export var color_orange_border = "Button-module--color_orange_border--86770";
export var color_red = "Button-module--color_red--e2739";
export var color_red_border = "Button-module--color_red_border--828df";
export var color_violet = "Button-module--color_violet--8d740";
export var color_white = "Button-module--color_white--03c77";
export var color_white_border = "Button-module--color_white_border--5ec08";
export var color_yellow = "Button-module--color_yellow--dd9a5";
export var color_yellow_border = "Button-module--color_yellow_border--1c579";